require('../../app.js')

Vue.component('modal', require('../../components/Modal.vue').default)
Vue.component('modal-opener', require('../../components/ModalOpener.vue').default)
Vue.component('show-more', require('../../components/ShowMore.vue').default)

Vue.component('estate-show-v1', require('./Show-v1.vue').default)
Vue.component('estate-show-v2', require('./Show-v2.vue').default)